import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import SharedProviders_0_0 from './extensions/return-request-extension/providers';
import SharedProviders_1_0 from './extensions/multivendor-extension/providers';
import SharedProviders_2_0 from './extensions/common/ui/providers';
import SharedProviders_3_0 from './extensions/custom-dashboard/ui/providers';
import SharedProviders_4_0 from './extensions/product-reviews/providers';
import SharedProviders_5_0 from './extensions/products-import/providers';
import SharedProviders_6_0 from './extensions/store-sites/providers';
import SharedProviders_7_0 from './extensions/vimeo/providers';
import SharedProviders_8_0 from './extensions/custom-admin-ui/providers';
import SharedProviders_9_0 from './extensions/site-pages/providers';
import SharedProviders_10_0 from './extensions/shipping/providers';
import SharedProviders_11_0 from './extensions/customizable-product/providers';
import SharedProviders_12_0 from './extensions/custom-promotions/providers';
import SharedProviders_13_0 from './extensions/google-products/providers';
import SharedProviders_14_0 from './extensions/erp-integrations/providers';
import SharedProviders_15_0 from './extensions/domain-manager/providers';


@NgModule({
    imports: [CommonModule, ],
    providers: [...SharedProviders_0_0, ...SharedProviders_1_0, ...SharedProviders_2_0, ...SharedProviders_3_0, ...SharedProviders_4_0, ...SharedProviders_5_0, ...SharedProviders_6_0, ...SharedProviders_7_0, ...SharedProviders_8_0, ...SharedProviders_9_0, ...SharedProviders_10_0, ...SharedProviders_11_0, ...SharedProviders_12_0, ...SharedProviders_13_0, ...SharedProviders_14_0, ...SharedProviders_15_0],
})
export class SharedExtensionsModule {}
